/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const TabbedFolder = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M16 3L19 7H23V21H1V3H16ZM2.5 8.5V19.5H21.5V8.5H2.5ZM8.251 4.5H2.5V7H10.125L8.251 4.5ZM15.251 4.5H10.125L12 7H17.125L15.251 4.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
